import { Box, Tabs as MaterialTabs, Tab } from "@mui/material";
import { useState } from "react";
import { TabPanel } from "./TabPanel";

export const Tabs = ({
  tabs,
  end,
}: {
  tabs: { label: React.ReactNode; tabComponent: React.ReactNode }[];
  // what stands at the end of the tabs' line
  end?: React.ReactNode;
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabIndex(newValue);
  };
  return (
    <>
      {/* the tabs sit on a line that runs across the page */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          borderBottom: 1,
          borderColor: "divider",
        }}
      >
        <MaterialTabs
          value={tabIndex}
          onChange={handleChange}
          // their labels in sentence case
          sx={{
            flex: 1,
            minWidth: 0,
            "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
          }}
        >
          {tabs.map(({ label }, index) => {
            return (
              <Tab
                key={"outcome_tab_" + index + "_" + label}
                label={label}
                id={"tab_" + index}
                sx={{ overflow: "visible" }}
              />
            );
          })}
        </MaterialTabs>
        {end}
      </Box>

      {tabs.map(({ tabComponent }, index) => (
        <TabPanel
          key={"tab_component_" + index}
          currentTabIndex={index}
          index={tabIndex}
        >
          {tabComponent}
        </TabPanel>
      ))}
    </>
  );
};
